module.exports = __webpack_public_path__ + "51dfaef72b5bc1f0f614ace3f0043542.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/11_A#2.mp3
// module id = 51
// module chunks = 0